import { j as r } from "./jsx-runtime.DGlMoOmv.js";
import { useFormContext as j } from "react-hook-form";
import { d as u, e as p, f as I, b as w, g as b } from "./Form.LdCd9gH2.js";
import { c as g } from "./index.CxSWpsOB.js";
import { I as h } from "./Input.D9O4R5sO.js";
const y = ({
  prefix: a,
  suffix: m,
  suffixText: t,
  testId: d = "input",
  className: l,
  inputClassName: n,
  label: s,
  subcopy: i,
  note: c,
  name: x,
  fullWidth: o = !1,
  ...e
}) => {
  const {
    control: f
  } = j();
  return /* @__PURE__ */ r.jsx(u, { control: f, name: x, render: ({
    field: F
  }) => /* @__PURE__ */ r.jsxs(p, { disabled: e.disabled, readOnly: e.readOnly, className: g({
    "tw-w-full tw-flex-1": o
  }, l), children: [
    !!s && /* @__PURE__ */ r.jsx(I, { subcopy: i, required: e.required, children: s }),
    /* @__PURE__ */ r.jsx(w, { forwardErrorMsg: !0, children: /* @__PURE__ */ r.jsx(h, { className: n, prefix: a, suffix: m, suffixText: t, testId: d, fullWidth: o, ...e, ...F }) }),
    /* @__PURE__ */ r.jsx(b, { children: c })
  ] }) });
};
y.displayName = "InputField";
export {
  y as I
};
//# sourceMappingURL=InputField.C5Go4vsr.js.map
